<template>
  <div>
    <el-dialog
      :title="$t('login.SMSLOGIN')"
      center
      :visible.sync="dialogVisible"
      @close="close"
      :close-on-click-modal="false"
    >
      <!-- <div class="box"> -->
      <div class="contain">
        <!-- <el-tabs stretch v-model="activeName">
          <el-tab-pane label="短信登录" name="first"> -->
        <div class="form1">
          <el-form
            ref="form1"
            :model="form1"
            :rules="rules1"
            label-width="auto"
          >
            <el-form-item prop="mobile" required>
              <el-input
                v-model="form1.mobile"
                :placeholder="$t('login.mobileNumber')"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="code" required>
              <el-input
                class="code-input"
                v-model="form1.code"
                :placeholder="$t('login.SMSCode')"
                clearable
              ></el-input>
              <el-button
                round
                size="mini"
                style="width:110px"
                :disabled="!canClick"
                @click="getMobileCode"
                >{{ content }}</el-button
              >
            </el-form-item>
            <el-form-item prop="captcha">
              <el-input
                class="code-input"
                v-model="form1.captcha"
                :placeholder="$t('login.captchaCode')"
                clearable
                name="captcha"
                type="text"
              />
              <div class="login-code" @click="getCode" v-html="codeUrl"></div>
            </el-form-item>
            <el-form-item>
              <el-button
                round
                style="width: 100%; background-color: #32589f; color: #ffffff"
                @click="loginbyMobile"
                >{{ $t("login.login") }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- </el-tab-pane>
          <el-tab-pane label="账号登录" name="second">
            <div class="form2">
              <el-form
                ref="form2"
                :model="form2"
                :rules="rules2"
                label-width="auto"
              >
                <el-form-item prop="mobile">
                  <el-input
                    v-model="form2.mobile"
                    placeholder="请输入手机号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    v-model="form2.password"
                    placeholder="请输入密码"
                    show-password
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    round
                    style="width: 100%"
                    @click="loginbyPass"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs> -->
        <!-- <div  class="codelink">
          <el-link :href="codeImg" target="_blank" type="primary"
            >微信二维码登录>>></el-link
          >
        </div> -->
      </div>
      <!-- <div class="qrcode">
          <iframe class="codeImg" :src="codeImg">
          <img
            class="codeImg"
            :src="codeImg"
          />
          </iframe>
        </div>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  getMobileCode,
  getCode,
  loginbyMobileCode,
  login,
  verifyToken,
  getWebSiteWeixinLogin,
} from "@/api/login";
import { localStorage } from "../../utils/storage";
export default {
  data() {
    return {
      dialogVisible: false,
      activeName: "first",
      content: this.$t("login.SEND"),
      totalTime: 60,
      canClick: true,
      form1: {},
      form2: {},
      codeUrl: "",
      codeImg: "",
      token: "",
      rules1: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
        ],
        code: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: ["blur", "change"],
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur", "change"],
          },
        ],
      },
      rules2: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.getCode();
      getWebSiteWeixinLogin()
        .then((res) => {
          if (res.code === 0) {
            this.codeImg = res.data;
          }
        })
        .catch((err) => {});
    },
    getCode() {
      getCode()
        .then((res) => {
          if (res.code == 0) {
            this.codeUrl = res.data.img;
            this.$set(this.form1, "captchaToken", res.data.captchaToken);
          }
        })
        .catch((err) => {});
    },
    close() {
      this.$refs.form1.resetFields();
      this.form1 = this.$options.data().form1;
      this.$refs.form2.resetFields();
      this.token = "";
      this.content = this.$options.data().content;
    },
    getMobileCode() {
      this.$refs.form1.validateField("mobile", (errorMsg) => {
        if (errorMsg) {
          return false;
        } else {
          if (!this.canClick) return;
          //倒计时
          this.canClick = false;
          this.content = this.totalTime + "s后再发送";
          let clock = window.setInterval(() => {
            this.totalTime--;
            this.content = this.totalTime + "s后再发送";
            if (this.totalTime < 0) {
              window.clearInterval(clock);
              this.content = "发送验证码";
              this.totalTime = 60;
              this.canClick = true; //这里重新开启
            }
          }, 1000);
          //
          getMobileCode(this.form1)
            .then((res) => {
              if (res.code == 0) {
                this.token = res.data.token;
              }
            })
            .catch((err) => {});
        }
      });
    },
    loginbyMobile() {
      this.$refs.form1.validate(async (valid) => {
        if (valid) {
          // let res = await verifyToken(this.form1);
          // if (res.code == 0) {
          //   if (!this.form1.code || this.form1.code != res.data) {
          //     this.$message.warning("验证码不正确");
          //     return;
          //   }
          // } else {
          //   this.$message.warning("验证码不正确");
          //   return;
          // }
          try {
            let data = await loginbyMobileCode({
              ...this.form1,
              token: this.token,
            });
            if (data.code === 0) {
              localStorage.set("xy-web-token", data.data.token);
              localStorage.set(
                "xy-web-userInfo",
                JSON.stringify(data.data.userInfo)
              );
              this.dialogVisible = false;
              this.$emit("loginSuccess");
            } else {
              this.getCode();
            }
          } catch {
            this.getCode();
          }
        } else {
          return false;
        }
      });
    },
    loginbyPass() {
      this.$refs.form2.validate(async (valid) => {
        if (valid) {
          let res = await login(this.form2);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.el-dialog__wrapper /deep/ .el-dialog {
  border-radius: 10px;
  width: 450px;
}
/* .el-dialog__wrapper /deep/ .el-dialog__header {
  padding: 0px;
} */
.el-dialog__wrapper /deep/.el-dialog__body {
  /* padding: 20px 20px 0px 20px; */
}
.contain /deep/ .el-tabs__header {
  width: 250px;
  margin: 0 auto;
}
.contain {
  width: 100%;
}
.form1,
.form2 {
  padding: 5%;
}
.codelink {
  margin-left: 5%;
  margin-top: -5%;
}
.el-input /deep/ .el-input__inner {
  border: 0px;
  border-bottom: 1px solid #dcdfe6;
}
.login-code {
  float: right;
  width: 110px;
  cursor: pointer;
}
.box {
  display: flex;
  flex-direction: row-reverse;
  /* justify-content: space-around; */
}
.code-input {
  width: calc(100% - 110px);
}
.qrcode {
  border-right: 1px solid #dcdfe6;
  width: 40%;
  margin: 0 auto;
}
.codeImg {
  width: 200px;
  height: 200px;
}
@media only screen and (max-width: 768px) {
  .box {
    display: block;
  }
  .el-dialog__wrapper /deep/ .el-dialog {
    width: 80%;
  }
  .el-dialog__wrapper /deep/.el-dialog__body {
    padding: 10px;
  }
  .contain /deep/ .el-tabs__header {
    width: 70%;
  }
  .contain {
    width: 100%;
    border-bottom: 1px solid #dcdfe6;
  }
  .qrcode {
    width: 100%;
    border-right: none;
    padding-top: 20px;
  }
  .codeImg {
    margin: 0 auto;
  }
}
</style>